/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc
 */
import * as References from './UsersRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#getUserIdsOnHubByRoleIdAndPendingStatus
 */
export const GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY_FIELD_NAME =
  'com_hubspot_appusers_rpc_UsersRpc_getUserIdsOnHubByRoleIdAndPendingStatus';
export const GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY: RegisteredQuery<
  'result',
  References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType,
  References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USER_IDS_ON_HUB_BY_ROLE_ID_AND_PENDING_STATUS_QUERY_FIELD_NAME,
  args: ['roleId', 'includePending', 'includeInactive'],
  fetcher(
    request: References.GetUserIdsOnHubByRoleIdAndPendingStatusRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUserIdsOnHubByRoleIdAndPendingStatusResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getUserIdsOnHubByRoleIdAndPendingStatusRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#filterOutInvisibleUsers
 */
export const FILTER_OUT_INVISIBLE_USERS_QUERY_FIELD_NAME =
  'com_hubspot_appusers_rpc_UsersRpc_filterOutInvisibleUsers';
export const FILTER_OUT_INVISIBLE_USERS_QUERY: RegisteredQuery<
  'result',
  References.FilterOutInvisibleUsersRequestType,
  References.FilterOutInvisibleUsersResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: FILTER_OUT_INVISIBLE_USERS_QUERY_FIELD_NAME,
  args: ['userIds'],
  fetcher(
    request: References.FilterOutInvisibleUsersRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.FilterOutInvisibleUsersResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.filterOutInvisibleUsersRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#getUsersByIds
 */
export const GET_USERS_BY_IDS_QUERY_FIELD_NAME =
  'com_hubspot_appusers_rpc_UsersRpc_getUsersByIds';
export const GET_USERS_BY_IDS_QUERY: RegisteredQuery<
  'result',
  References.GetUsersByIdsRequestType,
  References.GetUsersByIdsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USERS_BY_IDS_QUERY_FIELD_NAME,
  args: ['userIds'],
  fetcher(
    request: References.GetUsersByIdsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUsersByIdsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getUsersByIdsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#setUserPermissions
 */
export const SET_USER_PERMISSIONS_MUTATION_FIELD_NAME =
  'com_hubspot_appusers_rpc_UsersRpc_setUserPermissions';
export const SET_USER_PERMISSIONS_MUTATION: RegisteredQuery<
  'result',
  References.SetUserPermissionsRequestType,
  References.SetUserPermissionsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_USER_PERMISSIONS_MUTATION_FIELD_NAME,
  args: ['rolesByUserId'],
  fetcher(
    request: References.SetUserPermissionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetUserPermissionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setUserPermissionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#setUserPermissionsAndSeats
 */
export const SET_USER_PERMISSIONS_AND_SEATS_MUTATION_FIELD_NAME =
  'com_hubspot_appusers_rpc_UsersRpc_setUserPermissionsAndSeats';
export const SET_USER_PERMISSIONS_AND_SEATS_MUTATION: RegisteredQuery<
  'result',
  References.SetUserPermissionsAndSeatsRequestType,
  References.SetUserPermissionsAndSeatsResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: SET_USER_PERMISSIONS_AND_SEATS_MUTATION_FIELD_NAME,
  args: ['rolesAndSeatsByUserId'],
  fetcher(
    request: References.SetUserPermissionsAndSeatsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.SetUserPermissionsAndSeatsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.setUserPermissionsAndSeatsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.appusers.rpc.UsersRpc#addUserBulk
 */
export const ADD_USER_BULK_MUTATION_FIELD_NAME =
  'com_hubspot_appusers_rpc_UsersRpc_addUserBulk';
export const ADD_USER_BULK_MUTATION: RegisteredQuery<
  'result',
  References.AddUserBulkRequestType,
  References.AddUserBulkResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: ADD_USER_BULK_MUTATION_FIELD_NAME,
  args: [
    'users',
    'roleNames',
    'seatNames',
    'teamId',
    'secondaryTeamIds',
    'permissionSetIds',
    'presetId',
    'sendWelcomeEmail',
    'sendSlackInvite',
    'forceWelcomeEmail',
    'customMessage',
  ],
  fetcher(
    request: References.AddUserBulkRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.AddUserBulkResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.addUserBulkRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});
